var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAffiliateMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M246.666 437.917V238.75",
    stroke: "#DEDFE2",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M218.984 335.196C218.4 338.221 269.092 419.029 273.15 419.029C278.354 419.029 290.304 410.162 290.304 407.658C290.304 405.154 267.475 346.95 267.475 337.121C267.475 327.292 223.992 309.167 218.984 335.196Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210 460.417V238.75",
    stroke: "#DEDFE2",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M430.172 167.378L416.545 164.167L364.305 385.849L377.932 389.06L430.172 167.378Z",
    fill: "#DEDFE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M377.92 389.084L381.131 375.457L253.615 345.408L250.404 359.034L377.92 389.084Z",
    fill: "#DEDFE2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M279.583 90H210V137.083H279.583V90Z",
    fill: "#B4ACF9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M292.291 113.542L261.041 106.25V120.833L292.291 113.542Z",
    fill: "#B4ACF9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M228.958 117.083C230.914 117.083 232.499 115.498 232.499 113.542C232.499 111.586 230.914 110 228.958 110C227.002 110 225.416 111.586 225.416 113.542C225.416 115.498 227.002 117.083 228.958 117.083Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M244.792 117.083C246.748 117.083 248.333 115.498 248.333 113.542C248.333 111.586 246.748 110 244.792 110C242.836 110 241.25 111.586 241.25 113.542C241.25 115.498 242.836 117.083 244.792 117.083Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M260.626 117.083C262.582 117.083 264.167 115.498 264.167 113.542C264.167 111.586 262.582 110 260.626 110C258.67 110 257.084 111.586 257.084 113.542C257.084 115.498 258.67 117.083 260.626 117.083Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M302.004 226.292C309.583 192.012 326.25 152.65 356.746 140.704",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M385.22 138.75C397.916 143.842 403.332 159.537 403.332 171.25C403.332 236.667 389.866 302.133 382.082 307.083C368.332 315.833 304.116 295 298.332 281.25C296.62 277.179 296.282 265.667 297.916 250.808",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M356.746 140.704C357.158 135.436 357.224 130.147 356.942 124.871",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M380.416 105.417C379.999 107.917 380.833 129.166 386.666 142.5C385.387 144.546 377.674 148.158 369.791 148.912",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M371.833 104.813C368.408 117.204 360.763 125.834 351.875 125.834C339.792 125.834 330 109.884 330 90.2085C329.997 87.0677 330.253 83.932 330.767 80.8335",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M322.708 79.9542C306.633 76.4958 304.166 63.75 304.166 58.75C304.166 43.3333 317.916 42.9167 323.749 39.5833C330.391 35.7875 335.416 28.75 344.999 28.75C354.166 28.75 361.041 37.5 366.666 40.4167C376.249 45.4167 399.166 44.5833 399.166 62.0833C399.166 74.5833 394.583 77.9167 394.583 83.75C394.583 87.0833 395.416 88.3333 395.416 95C395.416 102.629 388.749 106.771 384.024 107.708",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M370.209 86.25C372.253 86.25 374.214 87.0621 375.66 88.5077C377.105 89.9533 377.917 91.914 377.917 93.9583C377.917 96.0027 377.105 97.9634 375.66 99.4089C374.214 100.855 372.253 101.667 370.209 101.667",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M348.541 218.75C346.212 224.338 342.708 234.167 342.083 243.333C335.833 240.833 275.833 213.75 264.583 213.75C242.499 213.75 236.666 220.833 236.666 224.167C236.666 230.417 263.749 229.583 267.499 231.667C271.249 233.75 345.416 282.083 354.583 282.083C362.862 282.083 382.366 250.121 386.666 236.879",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M397.188 223.958C394.771 231.667 391.805 236.962 389.167 237.083C380.001 237.5 346.667 220 344.167 214.583C342.501 211.012 355.001 186.054 369.438 172.221",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M257.084 233.333H44.584V241.667H257.084V233.333Z",
    fill: "#DEDFE2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 460.417V238.75",
    stroke: "#DEDFE2",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M95.834 437.917V238.75",
    stroke: "#DEDFE2",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M248.333 228.75H200.416V233.333H248.333V228.75Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M177.928 170.01L199.873 231.468L201.172 231.004L179.227 169.546L177.928 170.01Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M355.945 381.083L385.02 468.304",
    stroke: "#DEDFE2",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M285.308 428.521L257.688 465.229",
    stroke: "#DEDFE2",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M325.262 375.675L294.787 416.175",
    stroke: "#DEDFE2",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M280.099 365.033L213.232 453.892",
    stroke: "#DEDFE2",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M312.158 373.196L341.233 460.417",
    stroke: "#DEDFE2",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M378.788 308.421C360.225 313.15 303.75 294.096 298.333 281.25C297.934 280.194 297.654 279.097 297.5 277.979C272.958 271.667 246.525 267.017 223.529 267.017C185.717 267.017 154.779 432.6 154.779 435.454C157.813 436.346 178.329 439.204 178.329 439.204C178.329 439.204 229.725 334.287 231.154 327.15C236.329 330.717 301.525 364.617 326.696 364.617C354.283 364.617 380.142 336.283 380.142 310.196C380.142 309.754 379.675 309.167 378.788 308.421Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M177.612 437.329L172.324 468.8L122.074 460.829L161.824 453.096L165.158 435.25",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M287.626 407.454L305.784 433.7L264.209 463.025L287.309 429.762L277.251 414.65",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliateMarketing);
export default __webpack_public_path__ + "static/media/affiliate-marketing.f44e3c19442ed666685b38cf8dc30bb3.svg";
export { ForwardRef as ReactComponent };